'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroV2 = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _PortalContent = require('components/Portal/PortalContent');

var _CallToAction = require('components/CallToAction');

var _CmsCta = require('components/CmsPage/modules/CmsCta');

var _LeadGenFormContainer = require('features/LeadGenForm/LeadGenFormContainer');

var _FriendbuyWidgetContainer = require('components/Friendbuy/FriendbuyWidgetContainer');

var _colors = require('constants/colors');

var _multitrack = require('helpers/multitrack');

var _markdown = require('helpers/markdown');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  navAction: {
    id: 'hero.nav.action',
    defaultMessage: 'Get ClassPass'
  },
  waitlistAction: {
    id: 'hero.waitlist.action',
    defaultMessage: 'Join the waitlist'
  }
});

/* eslint-disable react/no-array-index-key */
var wrapLines = function wrapLines(lines, className) {
  return (lines || []).map(function (line, idx) {
    return _react2.default.createElement(
      'span',
      { className: className, key: 'line-' + idx },
      line
    );
  });
};
/* eslint-enable react/no-array-index-key */

var HeroV2 = exports.HeroV2 = function (_Component) {
  (0, _inherits3.default)(HeroV2, _Component);

  function HeroV2(props) {
    var _this, _this4;

    (0, _classCallCheck3.default)(this, HeroV2);

    _this = (_this4 = (0, _possibleConstructorReturn3.default)(this, (HeroV2.__proto__ || (0, _getPrototypeOf2.default)(HeroV2)).call(this, props)), _this4);

    _this4.handleFriendbuyWidgetClose = function () {
      return _this.setState({ displayFriendbuyWidget: false });
    };

    _this4.state = {
      displayFriendbuyWidget: false
    };
    _this4.handleCtaClick = _this4.handleCtaClick.bind(_this4);
    return _this4;
  }

  (0, _createClass3.default)(HeroV2, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          setPagePromotion = _props.setPagePromotion,
          promoAlias = _props.promoAlias;

      setPagePromotion(promoAlias);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.useSellHeader(false);
    }
  }, {
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Hero Module', 'Viewed module', null, 0, { nonInteraction: true });
    }

    // Logic specific to the hero on CTA click events

  }, {
    key: 'handleCtaClick',
    value: function handleCtaClick() {
      var cta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props2 = this.props,
          localCtaClick = _props2.ctaClick,
          isLive = _props2.isLive,
          isWelcomeHero = _props2.isWelcomeHero;


      if (isWelcomeHero && cta.type === _CmsCta.CMS_CTA_TYPES.URL) {
        (0, _multitrack.ga)('Refer-a-Friend', 'raf-hero-cta-click');
        this.setState({ displayFriendbuyWidget: true });
      } else if (isLive && cta.type === _CmsCta.CMS_CTA_TYPES.URL) {
        (0, _multitrack.ga)('CP Live Purchases', 'CP Live CTA Click', 'standalone');
      } else if (isLive) {
        (0, _multitrack.ga)('Top Nav', 'CP Live CTA Click', 'standalone');
      } else if (cta.type === _CmsCta.CMS_CTA_TYPES.URL || cta.type === _CmsCta.CMS_CTA_TYPES.OFFER_CHECKOUT) {
        (0, _multitrack.ga)('Hero Module', 'Clicked CTA');
      }

      localCtaClick();
    }
  }, {
    key: 'renderCtaSection',
    value: function renderCtaSection() {
      var _this2 = this;

      var ctas = this.props.ctas;


      var renderedCtas = ctas.map(function (cta, idx) {
        var renderedCta = _this2.renderCta(cta, idx === 0);
        return renderedCta && _react2.default.createElement(
          'span',
          { className: 'hero__cta', key: 'cta-' + cta.copy },
          renderedCta
        );
      }).filter(Boolean);

      return !(0, _verify.isEmpty)(renderedCtas) && _react2.default.createElement(
        'div',
        { className: 'hero__main-cta' },
        renderedCtas
      );
    }
  }, {
    key: 'renderCta',
    value: function renderCta(cta, isPrimary) {
      var _this3 = this;

      if (!cta.copy) {
        return null;
      }

      var interpolator = this.props.interpolator;


      var extraClass = (0, _classnames2.default)('bt--lg', 'hero__cta__button', (0, _defineProperty3.default)({
        'hero__cta__button--video': cta.type === _CmsCta.CMS_CTA_TYPES.YOUTUBE_VIDEO
      }, 'hero__cta__button--' + cta.color, cta.type === _CmsCta.CMS_CTA_TYPES.URL && cta.color && !(cta.color in _colors.CTA_COLOR_BY_NAME)));

      return _react2.default.createElement(_CmsCta.CmsCta, (0, _extends3.default)({}, cta, {
        copy: interpolator(cta.copy),
        extraClass: extraClass,
        isPrimary: isPrimary,
        onClick: function onClick() {
          return _this3.handleCtaClick(cta);
        }
      }));
    }
  }, {
    key: 'renderLeadCapture',
    value: function renderLeadCapture() {
      return _react2.default.createElement(
        'div',
        { className: 'hero__lead-gen' },
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          messages.waitlistAction,
          function (copy) {
            return _react2.default.createElement(_LeadGenFormContainer.LeadGenFormContainer, { ctaCopy: copy });
          }
        )
      );
    }
  }, {
    key: 'renderHeadingLines',
    value: function renderHeadingLines(lines, type) {
      var _props3 = this.props,
          cmsModuleId = _props3.cmsModuleId,
          interpolator = _props3.interpolator;

      return wrapLines(lines.map(interpolator).map(function (line, index) {
        return (0, _markdown.renderMarkdown)(line, 'hero_' + cmsModuleId + '_' + type + '_' + index);
      }), 'hero__layout__content__' + type + '__line');
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props4 = this.props,
          horizontalAlignment = _props4.horizontalAlignment,
          desktopImageUrl = _props4.desktopImageUrl,
          headerCtaCopy = _props4.headerCtaCopy,
          heroTextColor = _props4.heroTextColor,
          hideHeaderCta = _props4.hideHeaderCta,
          isRaf = _props4.isRaf,
          isWelcomeHero = _props4.isWelcomeHero,
          isLeadCapture = _props4.isLeadCapture,
          legal = _props4.legal,
          mobileImageUrl = _props4.mobileImageUrl,
          promoAlias = _props4.promoAlias,
          subtitle = _props4.subtitle,
          _props4$textJustifica = _props4.textJustification,
          textJustification = _props4$textJustifica === undefined ? 'left' : _props4$textJustifica,
          title = _props4.title,
          titleSize = _props4.titleSize,
          _props4$verticalAlign = _props4.verticalAlignment,
          verticalAlignment = _props4$verticalAlign === undefined ? 'middle' : _props4$verticalAlign;
      var displayFriendbuyWidget = this.state.displayFriendbuyWidget;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, 'hero hero--website-2-0 hero--' + heroTextColor, true), (0, _defineProperty3.default)(_classNames2, 'hero--raf', isRaf), (0, _defineProperty3.default)(_classNames2, 'hero--welcome', isWelcomeHero), _classNames2))
        },
        displayFriendbuyWidget && _react2.default.createElement(_FriendbuyWidgetContainer.FriendbuyWidgetContainer, { onClose: this.handleFriendbuyWidgetClose }),
        !hideHeaderCta && _react2.default.createElement(
          _PortalContent.PortalContent,
          { id: 'nav-cta' },
          _react2.default.createElement(
            _CallToAction.CallToAction,
            {
              action: _CallToAction.ACTIONS.LINK,
              extraClass: 'bt--primary bt--sm bt--text-sm header__bt',
              onClick: this.handleCtaClick,
              to: promoAlias ? '/pricing/' + promoAlias : '/pricing'
            },
            headerCtaCopy || _react2.default.createElement(_reactIntl.FormattedMessage, messages.navAction)
          )
        ),
        _react2.default.createElement('div', {
          className: (0, _classnames2.default)('hero__placeholder', 'hero__placeholder--sm', 'hero__placeholder--sm--' + verticalAlignment),
          style: mobileImageUrl ? { backgroundImage: 'url(' + mobileImageUrl + ')' } : {}
        }),
        _react2.default.createElement('div', {
          className: (0, _classnames2.default)('hero__placeholder', 'hero__placeholder--md', 'hero__placeholder--md--' + verticalAlignment),
          style: desktopImageUrl ? { backgroundImage: 'url(' + desktopImageUrl + ')' } : {}
        }),
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('hero__layout', 'hero__layout--' + horizontalAlignment, 'hero__layout--' + verticalAlignment, 'hero__layout--' + textJustification + '-justify')
          },
          _react2.default.createElement(
            'div',
            { className: 'hero__layout__content' },
            _react2.default.createElement(
              'h1',
              {
                className: (0, _classnames2.default)('hero__layout__content__title', 'hero__layout__content__title--' + titleSize)
              },
              this.renderHeadingLines(title, 'title')
            ),
            !(0, _verify.isEmpty)(subtitle) && _react2.default.createElement(
              'h2',
              { className: 'hero__layout__content__subtitle' },
              this.renderHeadingLines(subtitle, 'subtitle')
            ),
            isLeadCapture ? this.renderLeadCapture() : this.renderCtaSection(),
            // eslint-disable-next-line react/no-danger
            legal && _react2.default.createElement('p', { className: 'hero__terms', dangerouslySetInnerHTML: { __html: legal } })
          )
        )
      );
    }
  }]);
  return HeroV2;
}(_react.Component);

HeroV2.propTypes = {
  horizontalAlignment: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,
  cmsModuleId: _propTypes2.default.string,
  ctaClick: _propTypes2.default.func.isRequired,
  ctas: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
    color: _propTypes2.default.string,
    copy: _propTypes2.default.string,
    url: _propTypes2.default.string
  }), _propTypes2.default.shape({
    color: _propTypes2.default.string,
    copy: _propTypes2.default.string,
    theme: _propTypes2.default.string,
    videoId: _propTypes2.default.string
  })])).isRequired,
  desktopImageUrl: _propTypes2.default.string,
  headerCtaCopy: _propTypes2.default.string,
  heroTextColor: _propTypes2.default.oneOf(['light', 'dark']).isRequired,
  hideHeaderCta: _propTypes2.default.bool,
  interpolator: _propTypes2.default.func.isRequired,
  isLeadCapture: _propTypes2.default.bool,
  isLive: _propTypes2.default.bool,
  isRaf: _propTypes2.default.bool,
  isWelcomeHero: _propTypes2.default.bool,
  legal: _propTypes2.default.string,
  mobileImageUrl: _propTypes2.default.string,
  promoAlias: _propTypes2.default.string,
  setPagePromotion: _propTypes2.default.func.isRequired,
  subtitle: _propTypes2.default.arrayOf(_propTypes2.default.string),
  textJustification: _propTypes2.default.oneOf(['left', 'far-left', 'center', 'right']),
  title: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  titleSize: _propTypes2.default.oneOf(['display', 'display-small']),
  useSellHeader: _propTypes2.default.func.isRequired,
  verticalAlignment: _propTypes2.default.oneOf(['top', 'top-split', 'middle', 'middle-split', 'bottom', 'bottom-split'])
};